/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BulkImportRowError
 */
export interface BulkImportRowError {
    /**
     *
     * @type {number}
     * @memberof BulkImportRowError
     */
    rowIndex?: number;
    /**
     *
     * @type {string}
     * @memberof BulkImportRowError
     */
    make?: string;
    /**
     *
     * @type {string}
     * @memberof BulkImportRowError
     */
    model?: string;
    /**
     *
     * @type {string}
     * @memberof BulkImportRowError
     */
    reason?: string;
}

/**
 * Check if a given object implements the BulkImportRowError interface.
 */
export function instanceOfBulkImportRowError(
    value: object,
): value is BulkImportRowError {
    return true;
}

export function BulkImportRowErrorFromJSON(json: any): BulkImportRowError {
    return BulkImportRowErrorFromJSONTyped(json, false);
}

export function BulkImportRowErrorFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): BulkImportRowError {
    if (json == null) {
        return json;
    }
    return {
        rowIndex: json["rowIndex"] == null ? undefined : json["rowIndex"],
        make: json["make"] == null ? undefined : json["make"],
        model: json["model"] == null ? undefined : json["model"],
        reason: json["reason"] == null ? undefined : json["reason"],
    };
}

export function BulkImportRowErrorToJSON(
    value?: BulkImportRowError | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        rowIndex: value["rowIndex"],
        make: value["make"],
        model: value["model"],
        reason: value["reason"],
    };
}
